// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-toolbar-container-oqe2c {
  height: 52px;
  flex-shrink: 0;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding: 0px 8px 0px 20px;
  border-bottom: 1px solid var(--border-color);
}

.modal-toolbar-icon-fbyRG {
  margin-right: 16px;
}

.modal-toolbar-title-WIcXi {
  font-weight: 500;
  font-size: 16px;
}

.modal-toolbar-close-Axz4U {
  margin-left: auto;
}

.modal-toolbar-close-Axz4U {
  width: 44px;
  height: 44px;
  padding: 10px;
  border-radius: 50%;
}

.modal-toolbar-close-Axz4U:active {
  background-color: var(--active-color);
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/modal-toolbar/modal-toolbar.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":[".container {\n  height: 52px;\n  flex-shrink: 0;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  padding: 0px 8px 0px 20px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.icon {\n  margin-right: 16px;\n}\n\n.title {\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.close {\n  margin-left: auto;\n}\n\n.close {\n  width: 44px;\n  height: 44px;\n  padding: 10px;\n  border-radius: 50%;\n}\n\n.close:active {\n  background-color: var(--active-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `modal-toolbar-container-oqe2c`,
	"icon": `modal-toolbar-icon-fbyRG`,
	"title": `modal-toolbar-title-WIcXi`,
	"close": `modal-toolbar-close-Axz4U`
};
export default ___CSS_LOADER_EXPORT___;
